











import Vue from "vue";
import Wrapper from "./blocks/Wrapper.vue";

interface IStep {
  ID: string[] | null;
  type: StepType;
  hideActions?: boolean;
  tip?: {
    title: string;
    description: string;
  };
  route?: string;
}

type StepType = "final" | "step" | "introduction";

export default Vue.extend({
  name: "how-use-catalog",
  components: {
    Wrapper,
  },
  props: {
    isActive: { type: Boolean, default: false },
    isAuthorized: { type: Boolean, default: false },
  },
  data: () => ({
    currentStep: 0,
  }),
  watch: {
    step(step: IStep) {
      if (step.route) {
        this.$router.push(step.route);
      }
    },
    $route(route) {
      if (this.step.route && route.path !== this.step.route) {
        this.$router.push(this.step.route);
      }
    },
  },
  computed: {
    step(): IStep {
      return this.steps[this.currentStep];
    },
    steps(): IStep[] {
      return [
        {
          ID: null,
          hideActions: true,
          type: "introduction",
        },
        {
          ID: ["#catalog-table"],
          type: "step",
          tip: {
            title: "1. Рабочая область",
            description: `<p>Здесь находится ваша основная рабочая область, представленная в виде таблицы. Для каждого раздела выделена отдельная папка.</p>`,
          },
          route: "/catalog/1650",
        },
        {
          ID: [".table-header__name", ".table-header__price"],
          type: "step",
          tip: {
            title: "2. Сортировка элементов",
            description: `<p>Вы можете отсортировать элементы таблицы по различным параметрам. Сортировка производится по убыванию ( <span style="transform: rotate(-90deg); display: inline-block;margin-right: 3px;"><b> &#10094; </b></span> ) и по возрастанию ( <span style="transform: rotate(90deg); display: inline-block; margin-left: 3px;"><b> &#10094; </b></span>  ).</p>`,
          },
          route: "/catalog/1650",
        },
        {
          ID: [".table-header__action"],
          type: "step",
          tip: {
            title: "3. Отображение элементов",
            description: `<p>Некоторые элементы можно просматривать в виде списка либо таблицы.</p>`,
          },
          route: "/catalog/1650",
        },
        {
          ID: ["#catalog-search"],
          type: "step",
          tip: {
            title: "4. Поиск",
            description: `<p>Чтобы быстро найти товар, воспользуйтесь поиском по товарам. Искать можно по наименованию или артикулу товара. Результаты поиска отобразятся автоматически после начала ввода в поле запроса</p>`,
          },
          route: "/catalog/1650",
        },
        {
          ID: [".upperCategory-row", ".product-row"],
          type: "step",
          tip: {
            title: "5. Переходы в разделы",
            description: `<p>Чтобы перейти ко всем товарам раздела, нажмите на нужную вам папку. При переходе в конечный раздел вы попадете на список товаров.</p>`,
          },
          route: "/catalog/1650",
        },
        {
          ID: [".upperCategory-row.row-1"],
          type: "step",
          tip: {
            title: "6. Возвращение назад",
            description: `<p>Для того, чтобы перейти в ранее посещенный раздел, нажмите на нужную вам папку из списка разделов в рабочей области.</p>`,
          },
          route: "/catalog/1650",
        },
        {
          ID: [".product-row.row-1"],
          type: "step",
          tip: {
            title: "7. Просмотр и заказ товаров",
            description: `<p>Ознакомиться с нужным товаром можно нажав на его название в списке. <br><br> ${
              this.isAuthorized
                ? 'Заказать товар можно нажав кнопку "Оформить заказ"'
                : 'Вы еще не зарегистрированы на портале, поэтому цены и остатки для просмотра вам недоступны. Заказать товар без регистрации тоже не получится. Чтобы зарегистрироваться на портале, вам нужно оставить заявку на регистрацию, нажав на кнопку "Смотреть цены и остатки" и оставить нам ваши контактные данные, после чего наши менеджеры свяжутся с вами, подтвердят ваш аккаунт и вы сможете воспользоваться всеми функциями каталога.'
            }</p>`,
          },
          route: "/catalog/1650",
        },
        {
          ID: null,
          type: "final",
        },
      ];
    },
  },
  methods: {
    nav(index: number): void {
      if (index > 0) {
        if (this.currentStep < this.steps.length - 1) this.currentStep++;
        else this.currentStep = 0;
      } else {
        if (this.currentStep > 0) this.currentStep--;
        else this.currentStep = this.steps.length - 1;
      }
    },
    close({ complete }: { complete: boolean }) {
      this.currentStep = 0;
      this.$store.commit("common/SET_ONBOARDING", false, undefined);
      if (complete) localStorage.setItem("onBoarding", "complete");
    },
  },
});
